/**
 * React Query hook for fetching proposal detail data
 */
import { useQuery } from '@tanstack/react-query';
import { getProposalDetail } from '../services/ProposalServices';
/**
 * Hook for fetching proposal detail data
 * @param id - The proposal ID
 * @returns Query result with proposal data
 */
export default function useProposalDetail(id) {
    return useQuery(['proposal', id], () => getProposalDetail(id), {
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 3,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // exponential backoff with max of 30 seconds
        refetchOnWindowFocus: false,
        enabled: !!id
    });
}
